module.exports = __webpack_public_path__ + "assets/comp-4.afc8c9cc401553058b4185953cbdf6c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/login/comp-4.jpg
// module id = gClk
// module chunks = 0